// extracted by mini-css-extract-plugin
module.exports = {"slider":"Slider_slider__cffo3","sliderWithOverflow":"Slider_sliderWithOverflow__LSwm_"};